<template>
  <div class="content">
    <div class="header text-center">
      <h3 class="title">Історія</h3>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card card-timeline card-plain">
          <div class="card-body">
            <ul class="timeline">
              <li class="timeline-inverted">
                <div class="timeline-badge danger">
                  <i class="nc-icon nc-single-copy-04"></i>
                </div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <span class="badge badge-pill badge-danger">1994</span>
                  </div>
                  <div class="timeline-body">
                    <p>Історія холдингу бере свій початок від заснування в 1993 році у м. Любліні підприємства «Дует» і у 1994р. в м. Луцьку регіональної компанії «Модерн»,
                      з яких згодом «виросла» «Модерн-Експо». Вже за рік українське підприємство починає займатися власним виробництвом торгівельних меблів. 
                      Основними матеріалами на той час були дерево та скло.</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="timeline-badge success">
                  <i class="nc-icon nc-sun-fog-29"></i>
                </div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <span class="badge badge-pill badge-success">1994</span>
                  </div>
                  <div class="timeline-body">
                    <p>Modern-Expo була заснована. За рік компанія розпочала виробництво комерційних меблів.</p>
                  </div>
                </div>
              </li>
              <li class="timeline-inverted">
                <div class="timeline-badge info">
                  <i class="nc-icon nc-world-2"></i>
                </div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <span class="badge badge-pill badge-info">1996</span>
                  </div>
                  <div class="timeline-body">
                    <p>Виросли асортименти компанії: скляні конструкції, прості ДСП, трубки та модульна фурнітура для роздрібної торгівлі.</p>
                    <hr>
                  </div>
                </div>
              </li>
              <li>
                <div class="timeline-badge warning">
                  <i class="nc-icon nc-istanbul"></i>
                </div>
                <div class="timeline-panel">
                  <div class="timeline-heading">
                    <span class="badge badge-pill badge-warning">2000</span>
                  </div>
                  <div class="timeline-body">
                    <p>Перші верстати FinPower і Ideal Line. Компанія почала випускати стелажні системи та касові бокси.</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "About",
    mounted() {
    },

    destroyed() {
    },

    methods: {}
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/About.vue